import {Injectable} from '@angular/core';
import {DownloadService} from '../../generated/s3-download-client';
import {
  ImageIdResponse,
  ImageUploadResponse,
  VenueImageType,
  VenueService,
  SelfServiceService,
  EventImageType, LegalsService, LegalImageType
} from '../../generated/sales-terminal-client';
import {SnackService} from '../snack/snack.service';
import {Observable, tap} from 'rxjs';
import {LegalPersonService} from '../legalPerson/legalPerson.service';

@Injectable({
  providedIn: 'root',
})
export class ImageService {
  constructor(private downloadService: DownloadService,
              private venueService: VenueService,
              private selfServiceService: SelfServiceService,
              private snackService: SnackService) {}

  public getEventImageId(eventId: number, type: EventImageType = EventImageType.Cover): Observable<ImageIdResponse> {
    return this.selfServiceService.selfServiceEventIdImageIdPut(eventId, type).pipe(
      tap({ error: (e) => this.snackService.showBackendError(e) }));
  }

  public selfServiceUploadEventImage(eventId: number, imgId: string, imgPostfix?: string, type?: EventImageType, body?: Blob): Observable<ImageUploadResponse> {
    return this.selfServiceService.selfServiceEventIdImageImgIdPut(eventId, imgId, imgPostfix, type, body).pipe(
      tap({ error: (e) => this.snackService.showBackendError(e) }));
  }

  public downloadEventImage(filename: string, ownerCentreId: string, ignoreErrors?: boolean): Observable<Blob> {
    return this.downloadService.eventCentreIdFilenameGet(filename, ownerCentreId).pipe(
      tap({ error: (e) => !ignoreErrors && this.snackService.showBackendError(e) }));
  }

  public deleteEventImage(eventId: number): Observable<any> {
    return this.selfServiceService.selfServiceEventIdImageDelete(eventId)
      .pipe(tap({ error: (e) => this.snackService.showBackendError(e) }));
  }

  public getVenueImageId(venueId: number, type: VenueImageType): Observable<ImageIdResponse> {
    return this.venueService.venueIdImageIdPut(venueId, type)
      .pipe(tap({ error: (e) => this.snackService.showBackendError(e) }));
  }

  public selfServiceUploadVenueImage(venueId: number, type: VenueImageType, imgId: string, imgPostfix?: string, body?: Blob): Observable<ImageUploadResponse> {
    return this.selfServiceService.venueIdImageImgIdPut(venueId, type, imgId, imgPostfix, body).pipe(
      tap({ error: (e) => this.snackService.showBackendError(e) }));
  }

  public downloadVenueImage(filename: string, ownerCentreId: string): Observable<Blob> {
    return this.downloadService.venueCentreIdFilenameGet(filename, ownerCentreId).pipe(
      tap({ error: (e) => this.snackService.showBackendError(e) }));
  }

  public deleteVenueImage(venueId: number, type: VenueImageType): Observable<any> {
    return this.selfServiceService.venueIdImageDelete(venueId, type)
      .pipe(tap({ error: (e) => this.snackService.showBackendError(e) }));
  }

  public getLegalPersonImageId(legalPersonId: number, type: LegalImageType = LegalImageType.PurchaseEmail): Observable<ImageIdResponse> {
    return this.selfServiceService.legalpersonIdImageIdPut(legalPersonId, type).pipe(
      tap({ error: (e) => this.snackService.showBackendError(e) }));
  }

  public uploadLegalPersonImage(legalPersonId: number, imgId: string, imgPostfix?: string, type?: LegalImageType, body?: Blob): Observable<ImageUploadResponse> {
    return this.selfServiceService.legalpersonIdImageImgIdPut(legalPersonId, imgId, imgPostfix, type, body).pipe(
      tap({ error: (e) => this.snackService.showBackendError(e) }));
  }

  public downloadLegalImage(filename: string, ownerId: string): Observable<Blob> {
    return this.downloadService.legalPersonOwnerIdFilenameGet(filename, ownerId).pipe(
      tap({ error: (e) => this.snackService.showBackendError(e) }));
  }
}
